import * as React from "react";
import { cn } from "@/lib/cn";

/* ─── Root ─── */
export function Tooltip({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

/* ─── Trigger + Content combo ─── */
interface TooltipTriggerProps {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: "top" | "bottom";
  className?: string;
}

export function TooltipTrigger({ children, content, side = "top", className }: TooltipTriggerProps) {
  return (
    <span className={cn("relative inline-flex group", className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          "absolute left-1/2 -translate-x-1/2 z-50 px-2 py-1 rounded",
          "bg-fg text-bg text-[10px] font-mono whitespace-nowrap shadow-lg",
          "opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-150",
          side === "top" ? "bottom-full mb-1.5" : "top-full mt-1.5",
        )}
      >
        {content}
      </span>
    </span>
  );
}

/**
 * Simple standalone tooltip wrapper — wrap any element to add a tooltip.
 */
export function SimpleTooltip({
  children,
  label,
  side = "top",
  className,
}: {
  children: React.ReactNode;
  label: string;
  side?: "top" | "bottom";
  className?: string;
}) {
  return (
    <TooltipTrigger content={label} side={side} className={className}>
      {children}
    </TooltipTrigger>
  );
}
